import { DotsLoader, Sidecar } from '@eppendorf/vnls-react-components';
import { ReactElement, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { MonitoringDetail } from '$features/monitoring/detail/monitoring-detail';
import { useDeviceSnapshot } from '$features/monitoring/device-snapshot.api';

export function MonitoringDetailSidecar(): ReactElement {
  const [searchParams] = useSearchParams();

  const [isSidecarOpen, setIsSidecarOpen] = useState(true);
  const navigate = useNavigate();

  const { data: snapshot, isLoading: isLoadingSnapshot } = useDeviceSnapshot({
    manufacturer: searchParams.get('manufacturer')!,
    serialNumber: searchParams.get('serialNumber')!,
  });

  function handleSidecarOpenChange(): void {
    // Guard against Radix UI behavior for nested modals, where a click on the
    // background removes every modal (here: Sidecar (Dialog) and
    // DateRangePicker (Popover)), but reduces the data attribute for
    // react-remove-scroll (BODY[data-scroll-locked]) just by 1 and don't
    // remove `pointer-events: none;` on BODY.
    // With this fix only one modal (= DateRangePicker) gets closed and
    // data-scroll-locked changes from 2 to 1.
    const scrollLockCount = parseInt(document.body.dataset.scrollLocked ?? '0', 10);
    if (scrollLockCount > 1) return;

    setIsSidecarOpen(false);
    navigate({
      search: '',
    });
  }

  return (
    <Sidecar isOpen={isSidecarOpen} onOpenChange={() => handleSidecarOpenChange()}>
      <div className="flex flex__dir--column flex__ai--stretch h-full">
        {isLoadingSnapshot && <DotsLoader className="m-top-xxl" />}
        {!snapshot && !isLoadingSnapshot && <LoadingErrorHint className="m-top-xl" />}

        {snapshot && <MonitoringDetail snapshot={snapshot} />}
      </div>
    </Sidecar>
  );
}
